import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";

const Checkout = ({ location, cartItems, currency }) => {
    let cartTotalPrice = 0;

    return (
        <Fragment>
            <HtmlHeader title="Checkout" />
            <Breadcrumb />

            <div className="checkout-area pt-95 pb-100">
                <div className="container">
                    {cartItems && cartItems.length >= 1 ? (
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="billing-info-wrap">
                                    <h3>Billing Details</h3>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>First Name</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>Last Name</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="billing-info mb-20">
                                                <label>Company Name</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="billing-select mb-20">
                                                <label>Country</label>
                                                <select>
                                                    <option>Select a country</option>
                                                    <option>Azerbaijan</option>
                                                    <option>Bahamas</option>
                                                    <option>Bahrain</option>
                                                    <option>Bangladesh</option>
                                                    <option>Barbados</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="billing-info mb-20">
                                                <label>Street Address</label>
                                                <input className="billing-address" placeholder="House number and street name" type="text" />
                                                <input placeholder="Apartment, suite, unit etc." type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="billing-info mb-20">
                                                <label>Town / City</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>State / County</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>Postcode / ZIP</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>Phone</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="billing-info mb-20">
                                                <label>Email Address</label>
                                                <input type="text" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="additional-info-wrap">
                                        <h4>Additional information</h4>
                                        <div className="additional-info">
                                            <label>Order notes</label>
                                            <textarea
                                                placeholder="Notes about your order, e.g. special notes for delivery. "
                                                name="message"
                                                defaultValue={""}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <div className="your-order-area">
                                    <h3>Your order</h3>
                                    <div className="your-order-wrap gray-bg-4">
                                        <div className="your-order-product-info">
                                            <div className="your-order-top">
                                                <ul>
                                                    <li>Product</li>
                                                    <li>Total</li>
                                                </ul>
                                            </div>
                                            <div className="your-order-middle">
                                                <ul>
                                                    {cartItems.map((cartItem, key) => {
                                                        const discountedPrice = getDiscountPrice(cartItem.price, cartItem.discount);
                                                        const finalProductPrice = (cartItem.price * currency.currencyRate).toFixed(2);
                                                        const finalDiscountedPrice = (discountedPrice * currency.currencyRate).toFixed(2);

                                                        discountedPrice != null
                                                            ? (cartTotalPrice += finalDiscountedPrice * cartItem.quantity)
                                                            : (cartTotalPrice += finalProductPrice * cartItem.quantity);
                                                        return (
                                                            <li key={key}>
                                                                <span className="order-middle-left">
                                                                    {cartItem.displayName} X {cartItem.quantity}
                                                                </span>{" "}
                                                                <span className="order-price">
                                                                    {discountedPrice !== null
                                                                        ? currency.currencySymbol +
                                                                          (finalDiscountedPrice * cartItem.quantity).toFixed(2)
                                                                        : currency.currencySymbol +
                                                                          (finalProductPrice * cartItem.quantity).toFixed(2)}
                                                                </span>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                            <div className="your-order-bottom">
                                                <ul>
                                                    <li className="your-order-shipping">Shipping</li>
                                                    <li>Free shipping</li>
                                                </ul>
                                            </div>
                                            <div className="your-order-total">
                                                <ul>
                                                    <li className="order-total">Total</li>
                                                    <li>{currency.currencySymbol + cartTotalPrice.toFixed(2)}</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="payment-method"></div>
                                    </div>
                                    <div className="place-order mt-25">
                                        <button className="btn-hover">Place Order</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-empty-area text-center">
                                    <div className="item-empty-area__icon mb-30">
                                        <i className="pe-7s-cash"></i>
                                    </div>
                                    <div className="item-empty-area__text">
                                        No items found in cart to checkout <br />{" "}
                                        <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                            Shop Now
                                        </LinkWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

Checkout.propTypes = {
    cartItems: PropTypes.array,
    currency: PropTypes.object,
    location: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        cartItems: state.cartData,
        currency: state.currencyData,
    };
};

export default connect(mapStateToProps)(Checkout);
